import { Component, Inject, OnInit } from '@angular/core';
import { FormModalBaseComponent } from '../../../../../../core/base/components/form-modal-base/form-modal-base.component';
import { ContractModel } from '../../../../../../core/models/contract.model';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ContractService } from '../../contract.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SnackbarService } from '../../../../../../core/services/snackbar.service';

@Component({
  selector: 'vex-contract-archive-delete',
  templateUrl: './contract-archive-delete.component.html',
  styleUrls: ['./contract-archive-delete.component.scss'],
})
export class ContractArchiveDeleteComponent extends FormModalBaseComponent<ContractModel> implements OnInit {
  form: UntypedFormGroup;
  contract: ContractModel;
  minDate: Date;
  maxDate: Date;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FormModalBaseComponent<ContractModel>>,
    public service: ContractService,
    private snackbar: SnackbarService,
  ) {
    super(data, dialogRef, service);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.contract = this.data.defaults;
    this.minDate = this.contract.startValidityDate ? new Date(this.contract.startValidityDate) : null;
    this.maxDate = new Date();
    this.maxDate.setHours(0, 0, 0, 0);
    this.maxDate.setDate(this.maxDate.getDate() - 1);
    this.form = new UntypedFormGroup({
      endValidityDate: new UntypedFormControl(this.maxDate, [Validators.required]),
    });
  }
  archive(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.loading = true;
    const endDate = this.form.controls.endValidityDate.value;
    this.service.archive(this.contract, endDate).subscribe({
      next: () => {
        this.snackbar.success('Le contrat a été archivé');
        this.loading = false;
        this.close(true);
      },
      error: () => {
        this.loading = false;
      },
    });
  }
}
